import React, { useEffect, useState } from 'react';
import api from '../api';
import { ruoloLabel } from '../lib/ruoli';

// Elenco persone del team (non agenti), caricato una volta e condiviso fra i picker della pagina.
let cache = null;
let pending = null;
export function useTeam() {
  const [team, setTeam] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    pending = pending || api.get('/team', { silent: true })
      .then(r => { cache = (r.data || []).filter(u => u.ruolo !== 'agente' && u.attivo !== false); return cache; })
      .catch(() => { pending = null; return []; });
    pending.then(setTeam);
  }, []);
  return team;
}

export const nomeCompleto = (u) => `${(u?.nome || '').trim()} ${(u?.cognome || '').trim()}`.trim();

/** <select> di una persona del team. `preferRuoli` mette in cima i ruoli più pertinenti. */
export default function PersonaPicker({ value, onChange, placeholder = '— Nessuno —', preferRuoli = [], style, disabled }) {
  const team = useTeam();
  const ordinati = [...team].sort((a, b) => {
    const pa = preferRuoli.includes(a.ruolo) ? 0 : 1, pb = preferRuoli.includes(b.ruolo) ? 0 : 1;
    return pa - pb || nomeCompleto(a).localeCompare(nomeCompleto(b));
  });
  return (
    <select className="eden-input" value={value || ''} disabled={disabled}
      onChange={e => onChange(e.target.value || null)} style={style}>
      <option value="">{placeholder}</option>
      {ordinati.map(u => (
        <option key={u.id} value={u.id}>{nomeCompleto(u)} · {ruoloLabel(u.ruolo)}</option>
      ))}
    </select>
  );
}
